// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"v70PF","modalControls":"I4UsM","postsHead":"_2Wiui","count":"_3_pgA","posts":"_2PwP2","post":"mpU5T","title":"_1P0KJ","search":"_22DRk"};